import { render, staticRenderFns } from "./FacebookFollow.vue?vue&type=template&id=2cd887fa&"
import script from "./FacebookFollow.vue?vue&type=script&lang=ts&"
export * from "./FacebookFollow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports